var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayerForward = function SvgPlayerForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CBCBCB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.271 14.625h5.688V8.938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CBCBCB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.25 17.875a9.75 9.75 0 0 1 16.646-6.896l3.25 3.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M9.783 22.12q0-1.225-.048-2.053a7.5 7.5 0 0 0-.228-1.5l.66-.143q.192.48.276 1.524.084 1.043.084 2.16v4.08h-.744zm4.213 4.067q-.552 0-1.02-.264a2.14 2.14 0 0 1-.732-.731 2.04 2.04 0 0 1-.264-1.02q0-.54.264-.997.276-.468.732-.732a1.97 1.97 0 0 1 1.02-.276q.54 0 .996.276.468.264.732.732.276.456.276.997 0 .55-.276 1.02-.264.454-.732.732a1.95 1.95 0 0 1-.996.264m0-.744q.516 0 .888-.372t.372-.9q0-.515-.372-.887a1.21 1.21 0 0 0-.888-.372q-.528 0-.9.372-.372.36-.372.888 0 .526.372.9.372.372.9.372"
  })));
};
export default SvgPlayerForward;